export enum ToastKey {
  ip_access = 'ip_access',
}
